import * as React from "react";
import { BinHintsTable } from './BinHintsTable.js';
import { Popup } from '../../genericComponents/index.js';
export function BinHintsPopup({ binsHints, decimals }) {
    return (React.createElement(Popup, { label: "Odhad po\u010Dtu t\u0159\u00EDd", content: React.createElement(BinHintsTable, { binsHints: binsHints, decimals: decimals }) }));
}
//# sourceMappingURL=BinHintsPopup.js.map